export const isNetworkError = (error: Error) => error.message === 'Network Error'
